import { Helmet } from "react-helmet-async";
import Container from "@mui/material/Container";
import Recordables from "./Recordables";
import { useSettingsContext } from "../contexts/SettingsContext";

// ----------------------------------------------------------------------

export default function RecordablesPage() {
  const settings = useSettingsContext();
  return (
    <>
      <Helmet>
        <title>TitleQ Recordables</title>
      </Helmet>

      <Container maxWidth={settings.themeStretch ? false : "xl"}>
        <Recordables />
      </Container>
    </>
  );
}
